// noinspection JSIgnoredPromiseFromCall

import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { postAudioSchema } from '../../services/AudioSchemaService';
import { AudioSchema, AudioSchemaPostRequest } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchema, Error, AudioSchemaPostRequest>;

function usePostAudioSchema(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(postAudioSchema, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePostAudioSchema;
